<div class="month-select-wrapper">
  <button class="arrow left" (click)="previousArrowClicked.emit()">
    <wchfs-icon size="24" svgIcon="pso:arrow_left_gray"></wchfs-icon>
  </button>
  <div class="date">{{ text }}</div>
  <button class="arrow" (click)="nextArrowClicked.emit()">
    <wchfs-icon size="24" svgIcon="pso:arrow_right_gray"></wchfs-icon>
  </button>
</div>
